<script>
    import vulnerabilityService from '../service.js';
    import { createEventDispatcher } from 'svelte';
    import { afterUpdate } from 'svelte';
    import { format } from 'svelte-i18n';

    const dispatch = createEventDispatcher();
    const md = new window.markdownit();

    export let note;
    export let vul_id;

    let formData = {
        content: note.content === $format("errors.vul_no_note") ? "" : note.content,
    };

    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};

	let result = '';

	afterUpdate(() => {
		result = md.render(formData.content);
	});


    function handleSubmit(config = {}) {

        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        //formData.content = markdown;

        vulnerabilityService.upsertNote(vul_id, formData, {})
            .then(savedNote => {
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                APIerror = null;

                dispatch("resetNoteWidget");
                return true;
            })
            .catch(errors => {
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                APIerror = null;
                dispatch("resetNoteWidget")
                return false;
            })
        ;
        handleCloseForm();
    }


    function handleCloseForm(){
        formData = {content: note.content === $format("errors.vul_no_note") ? "" : note.content};
        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        formIsSubmitted = false;
        dispatch("hideNoteForm")
    }

</script>
<style>
    select {
        max-width: 400px;
    }
    .markdown-editor {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.markdown-editor__panel {
		width: calc(50% - 1rem);
		height: 300px;
		box-sizing: inherit;
	}

	.markdown-editor__panel__label {
		display: block;
		font-weight: 700;
		margin-bottom: 0.75rem;
	}

	.markdown-editor__textarea, .markdown-editor__result-html {
		box-sizing: inherit;
		height: 100%;
		width: 100%;
		padding: 1rem;
		/*border: 1px solid black;*/
	}

	.markdown-editor__textarea {
		margin: 0;
	}

	.markdown-editor__result-html {
		overflow-y: scroll;
	}
</style>

<form role="form" novalidate on:submit|preventDefault={handleSubmit}>
    <div class="markdown-editor mb-5">
        <div class="markdown-editor__panel">
            <span class="markdown-editor__panel__label">Markdown</span>
            <textarea id="noteAddFormMarkdown" class="markdown-editor__textarea form-control" bind:value={formData.content} />
        </div>
        <div class="markdown-editor__panel">
            <span class="markdown-editor__panel__label">{$format("preview")}</span>
            <div class="markdown-editor__result-html form-control">
                {@html result}
            </div>
        </div>
    </div>
    <div class="mt-5">
        <button type="submit" class="btn btn-primary t-submit-note-btn">{$format("buttons.save")}</button>
        <button class="btn btn-default" on:click={handleCloseForm}>{$format("buttons.cancel")}</button>
    </div>
</form>